<template>
  <div class="slider-card">
    <div class="slider-card-header" >
      <img :src="image" v-if="!isLoading" class="header-image header-image-padding" />
      <free-style-shimmer
          class="header-image"
          :is-loading="isLoading"
          color="#EAECF0"
          height="160px"
          width="100%"
      />
      <router-link :to="to">
        <button class="details-button" v-if="!isLoading">
          {{$t('details')}}
        </button>
      </router-link>
    </div>


    <div class="slider-card-body">
      <h2 v-if="!isLoading">
        {{ title }}
      </h2>
      <free-style-shimmer
          :is-loading="isLoading"
          height="12px"
          width="120px"
          border-radius="50px"
          color="#EAECF0" />

    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: 'https://i.hizliresim.com/lyhe30g.jpg'
    },
    title: {
      type: String,
      default: 'Blog Name'
    },
    to: {
      type: String,
      default: '/programs'
    }
  },
  methods: {
    formatDate(dateStr) {
      try {
        const date = new Date(dateStr);
        const options = {year: 'numeric', month: 'short', day: 'numeric'};
        return date.toLocaleDateString("en", options);
      } catch (e) {
        return '-';
      }
    },
  }
};
</script>

<style scoped>
.slider-card {
  width: 100%;
  height: 100%;
  background-color: #F9FAFB;
  border: 1px solid #EAECF0;
  border-radius: 16px;
}

.slider-card-header {
  position: relative;
}

.details-button {
  visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: #4A68F8;
  border-radius: 16px;
  padding: 5px 20px;
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #FFFFFF;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
}

.slider-card:hover .details-button {
  opacity: 1;
  visibility: visible;
}

.header-image {
  width: 100%;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  height: 160px;
  object-fit: contain;
  background-color: #F5F5F5;
}

.header-image-padding {
  padding: 15px;
}

.slider-card-body {
  padding: 15px;
}

h2 {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #101828;
}

h4 {
  font-family: euclid_regular, sans-serif;
  color: #667085;
  font-size: 12px;
  margin-bottom: 15px;
}

.program-tag {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #101828;
  background-color: #E9EAEF;
  border-radius: 8px;
  padding: 3px 12px;
}

.paragraph-shimmer.top {
  margin-top: 15px;
}

.paragraph-shimmer {
  margin-bottom: 5px;
}

.tag-column {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 15px;
}
</style>
